import { render } from "./SAASBlackSection.vue?vue&type=template&id=2f070ce7&scoped=true"
const script = {}

import "./SAASBlackSection.vue?vue&type=style&index=0&id=2f070ce7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f070ce7"]])

export default __exports__